import { createReducer } from 'deox';
import { setLockLevel, setStakedAmount, setTier, setTierReference, setTimeStaked, setTimeUnlock, setStakeInformation } from './actions';
import { initTiers, IStakingReducer, StakeInformation, Tiers } from '../../types/reducerTypes';
import Big from 'big.js';

const initialState: IStakingReducer = {
  stakedAmount: new Big(0),
  timeStaked: '-',
  timeUnlock: 0,
  tier: Tiers.NONE,
  tierReference: initTiers,
  lockLevel: '1',
  stakeInformation: undefined,
}

const stakingReducer = createReducer(initialState, (handleAction) => [
  handleAction(setStakedAmount, (state, { payload }) => ({
    ...state,
    stakedAmount: payload,
  })),
  handleAction(setTier, (state, { payload }) => ({
    ...state,
    tier: payload,
  })),
  handleAction(setTimeUnlock, (state, { payload }) => ({
    ...state,
    timeUnlock: payload,
  })),
  handleAction(setTimeStaked, (state, { payload }) => ({
    ...state,
    timeStaked: payload,
  })),
  handleAction(setTierReference, (state, { payload }) => ({
    ...state,
    tierReference: payload,
  })),
  handleAction(setLockLevel, (state, { payload }) => ({
    ...state,
    lockLevel: payload,
  })),
  handleAction(setStakeInformation, (state, { payload }) => ({
    ...state,
    stakeInformation: {
      ...state.stakeInformation,
      [payload.tierIndex]: payload.stakeInformation,
    },
  })),
]);

export default stakingReducer;
